import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const LockIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '90%'}
      height={circled ? '50%' : '90%'}
      viewBox="0 0 16.7 22"
    >
      <g transform="translate(1 1)">
        <line
          y2="2.609"
          transform="translate(7.35 13.043)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          width="14.7"
          height="12.174"
          transform="translate(0 7.826)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M9.574,136.283a4.756,4.756,0,1,1,9.512,0v3.043H9.574Z"
          transform="translate(-6.979 -131.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
